import { Banner, BannerProps } from "@validereinc/common-components";
import { SystemActionTypeType, WorkflowTaskTypes } from "@validereinc/domain";
import React from "react";

type SystemActionProgressBannerContentType = {
  titleText: BannerProps["titleText"];
  description?: BannerProps["description"];
};

const SYSTEM_ACTION_PROGRESS_BANNER_CONTENT: Record<
  SystemActionTypeType,
  SystemActionProgressBannerContentType
> = {
  [WorkflowTaskTypes.RUN_TEMPLATED_REPORT]: {
    titleText: "Running the report...",
  },
  [WorkflowTaskTypes.RUN_CALCULATIONS]: {
    titleText: "Running calculations...",
  },
  [WorkflowTaskTypes.ASSESS_TEMPLATED_REPORT_FOR_COMMENTS]: {
    titleText: "Checking for comments...",
  },
  [WorkflowTaskTypes.RUN_DEFAULT_RECORD_VALUE_CONFIGURATION]: {
    titleText: "Applying record automation...",
  },
  [WorkflowTaskTypes.LOCK_RECORD]: {
    titleText: "Locking records...",
  },
  [WorkflowTaskTypes.UNLOCK_RECORD]: {
    titleText: "Unlocking records...",
  },
  [WorkflowTaskTypes.LOCK_REPORT]: {
    titleText: "Locking report...",
  },
  [WorkflowTaskTypes.UNLOCK_REPORT]: {
    titleText: "Unlocking report...",
  },
  [WorkflowTaskTypes.CREATE_EVENT]: {
    titleText: "Creating the event...",
    description:
      "You may view event details below and go to the event page after the automation completes.",
  },
  [WorkflowTaskTypes.CREATE_FORM]: {
    titleText: "Creating the form...",
    description:
      "You may view submission details below and go to the submission page after the automation completes.",
  },
  [WorkflowTaskTypes.FORM_CHOICE]: {
    titleText: "Scanning form...",
    description:
      "Scanning the form to select the correct path based off the choice selection.",
  },
  [WorkflowTaskTypes.VARIABLE_CHOICE]: {
    titleText: "Evaluating variables...",
    description: "Evaluating workflow variables to determine the correct path.",
  },
  [WorkflowTaskTypes.DELAY]: {
    titleText: "This delay is currently running",
  },

  [WorkflowTaskTypes.UPDATE_CUSTOM_ATTRIBUTES]: {
    titleText: "Updating asset custom attributes...",
  },
  [WorkflowTaskTypes.UPDATE_ATTRIBUTES]: {
    titleText: "Updating asset attributes...",
  },
  [WorkflowTaskTypes.SEND_REPORT]: {
    titleText: "Sending report...",
  },
  [WorkflowTaskTypes.SEND_NOTIFICATION]: {
    titleText: "Sending notification...",
  },
  [WorkflowTaskTypes.CTR_CONSENSUS_CHOICE]: {
    titleText: "Making consensus choice...",
  },
  [WorkflowTaskTypes.RUN_WORKER]: {
    titleText: "Running worker...",
  },
  [WorkflowTaskTypes.GENERIC_SYSTEM_ACTION]: {
    titleText: "Executing action...",
  },
};

export const SystemActionProgressBanner = ({
  workflowStepType,
}: {
  workflowStepType: SystemActionTypeType;
}) => {
  const { titleText, description } = SYSTEM_ACTION_PROGRESS_BANNER_CONTENT[
    workflowStepType
  ] ?? {
    titleText: "",
  };

  return (
    <Banner
      titleText={titleText}
      {...(description ? { description } : {})}
      color="loading"
      variant="loading"
    />
  );
};
